<template>
  <el-select
    clearable
    filterable
    :multiple="props.config.multiple || false"
    :collapse-tags="Boolean(props.config.multiple)"
    :collapse-tags-tooltip="
      Boolean(props.config['collapse-tags'] || props.config.multiple)
    "
    v-bind="{ ...$attrs, ...props.config }"
  >
    <el-option
      v-for="(item, index) in props.config.options"
      :key="index"
      :disabled="item.disabled ?? false"
      :value="item.value"
      :label="$t(item.label || '')"
    />
  </el-select>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "search-select",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
